import {
  Visibility,
  type VisibilityConfigFieldsFragment,
  type VisibilityConfigInput
} from '~/api/graphql';

export interface VisibilitySelectorValue {
  level: Visibility;
  userIds: string[];
  teamIds: string[];
}

/**
 * Convert a server-side VisibilityConfigFields fragment (or null) into the
 * selector's local state shape. Defaults to PUBLIC when no value is supplied.
 */
export const visibilityValueFromFragment = (
  visibility: VisibilityConfigFieldsFragment | null | undefined
): VisibilitySelectorValue => ({
  level: visibility?.level ?? Visibility.Public,
  userIds: visibility?.userIds ?? [],
  teamIds: visibility?.teamIds ?? []
});

/**
 * Convert the selector's value into a VisibilityConfigInput payload suitable
 * for a mutation. Empty access lists are normalized to undefined so the
 * server-side normalize step receives the canonical "no list" signal.
 */
export const visibilityInputFromValue = (
  value: VisibilitySelectorValue
): VisibilityConfigInput => ({
  level: value.level,
  userIds: value.level === Visibility.Shared ? value.userIds : undefined,
  teamIds: value.level === Visibility.Shared ? value.teamIds : undefined
});

/** Inverse of `visibilityInputFromValue` for seeding create/edit forms from API input. */
export const visibilityValueFromInput = (
  visibility: VisibilityConfigInput | null | undefined
): VisibilitySelectorValue => ({
  level: visibility?.level ?? Visibility.Public,
  userIds: visibility?.level === Visibility.Shared ? (visibility.userIds ?? []) : [],
  teamIds: visibility?.level === Visibility.Shared ? (visibility.teamIds ?? []) : []
});
